'use strict';

const returnTimer = require('../countDownTimer');
const utils = require('../utils');
const constants = require('../constants');

/**
 * Calculate Order Countdown Time
 */
function orderCountDownTimer() {
    const data = document.querySelectorAll('.mode-active');
    data.forEach(item => {
        const orderId = $(item).data('orderid');
        var orderCountDownContainer = document.getElementById('order-countdown-' + orderId);
        setInterval(function () {
            var orderCreationDate = $(item).data('ordercreation');
            var defaultTimeValue = $(item).data('expirationtimer');
            var leftTime = returnTimer(defaultTimeValue, orderCreationDate);
            orderCountDownContainer.innerHTML = leftTime;
            if (leftTime === 0) {
                utils.fadeOut($('#order-' + orderId));
            }
        }, 1000);
    });
}

/**
 * Handling the remorse period for cancel orders
 */
function handlingCancelRemorsePeriodOver() {
    let params = utils.getQueryStringParams(window.location.href);
    if (params && params.timeExceedErr) {
        $('#maincontent').prepend(utils.showErrorToast(params.timeExceedErr));
    }
}


module.exports = function () {
    $(function () {
        orderCountDownTimer();
        handlingCancelRemorsePeriodOver();
        if (utils.getCurrentBreakpoint() === 'mobile') {
            var elem = $('.cancel-edit-order-item  .order-action-btn').first();
            $('<br>').insertBefore(elem);
        }
        $('select#historyDropdown').prop('selectedIndex', function () {
            var selected = $(this).children('[selected]').index();
            return selected !== -1 ? selected : 0;
        });
    });

    $('body').on('change', '.order-history-select', function (e) {
        var $ordersContainer = $('.order-list-container');
        var loader = $('.order-loader');
        $ordersContainer.empty();
        loader.removeClass('d-none');
        var emptyHistoryBlock = $('.order-history__empty');
        if (emptyHistoryBlock.length > 0) {
            emptyHistoryBlock.addClass('d-none');
        }
        $('.order-history-select').trigger(constants.events.ORDERHISTORY_SORT, e);
        $.ajax({
            url: e.currentTarget.value,
            method: 'GET',
            success: function (data) {
                loader.addClass('d-none');
                // eslint-disable-next-line no-extra-boolean-cast
                if (!!(data.trim())) {
                    $ordersContainer.html(data);
                    orderCountDownTimer();
                } else {
                    const orderMessage = $('.js-no-order-found').html();
                    $ordersContainer.html(orderMessage);
                    // only show "place an order" and Start Shopping button,
                    //   if no results in past 6 months
                    if (emptyHistoryBlock.length > 0 && e.currentTarget.value.indexOf('6M') >= 0) {
                        emptyHistoryBlock.removeClass('d-none');
                    }
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                loader.removeClass('d-none');
            }
        });
    });

    $(document).on('click', '#edit-action-btn', function () {
        let dataURL = $(this).data('url');
        $.ajax({
            url: dataURL,
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                if (data && data.redirectUrl) {
                    $('.editOrderHistoryModal').modal('hide');
                    window.location.href = data.redirectUrl;
                }
            },
            error: function (data) {
                if (data && data.responseJSON && data.responseJSON.errorMsg) {
                    $('.editOrderHistoryModal').modal('hide');
                    $('#maincontent').prepend(utils.showErrorToast(data.responseJSON.errorMsg));
                }
            }
        });
    });

    $(document).on('click', '#cancelOrderHistoryBtn', function () {
        $(this).attr('disabled', true);
        let dataURL = $(this).data('url');
        var orderId = $(this).data('orderid');
        if ($('.orderdetailpage #cancelOrderHistoryBtn').length > 0) {
            let cancelToastMessage = $(this).data('canceltoastmessage');
            $('.cancelOrderHistoryModal').modal('hide');
            utils.showConfirmToast(cancelToastMessage);
            window.location.href = dataURL;
            return;
        }
        $.ajax({
            url: dataURL,
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                $('.cancelOrderHistoryModal').modal('hide');
                document.getElementById('order-status-' + orderId).innerHTML = 'Canceled';
                utils.fadeOut($('#order-' + orderId));
                utils.showConfirmToast(data.cancelMsg);
            },
            error: function (data) {
                $('.cancelOrderHistoryModal').modal('hide');
                if (data && data.responseJSON && data.responseJSON.errorMsg) {
                    $('.cancelOrderHistoryModal').modal('hide');
                    utils.showErrorToast(data.responseJSON.errorMsg);
                }
            }
        });
    });

    $(document).on('click', '.dismiss-alert', function () {
        $(this).closest('.alert').remove();
    });
};
